<template>
  <v-form ref="form" v-model="valid" action="javascript:void(0);" class="pa-8">
    <p class="d-block text-body-1 mb-8 text-center">Se hai già acquistato un biglietto, controlla la tua casella di posta, apri la mail che ti è stata inviata, copia il codice e inseriscilo nel box qua sotto.</p>
    <v-row align="center" justify="center"><v-text-field class="col col-auto mb-4" outlined v-model="code" required label="Ticket" :rules="codeRules" :error-messages="error" /></v-row>
    <v-row align="center" justify="center"><v-btn class="col col-auto mb-8 px-16" depressed rounded light large :loading="saving" type="submit" @click="submit">Confirm</v-btn></v-row>
    <a class="text-body-2 text-center d-block text-decoration-none" href="https://www.mailticket.it/manifestazione/E931" rel="nofollow" target="_blank">I don't have a ticket,&nbsp;<span class="text-decoration-underline blue--text text--lighten-4">Shop Here</span></a>
  </v-form>
</template>

<script>
import axios from 'axios'
import md5 from 'md5'
import UpdateUser from '@/graphql/mutations/UpdateUser.gql'

export default {
  name: 'MailTicketForm',
  data () {
    return {
      saving: false,
      valid: false,
      code: null,
      error: null,
      codeRules: [
        v => (!!v && v.length > 1) || this.$gettext('Required Field')
      ]
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        this.saving = true
        const config = {
          headers: {
            'Content-Type': 'text/xml; charset=utf-8'
            // SOAPAction: 'https://wsfiscale.mailticket.it/VerificaBiglietto'
          }
        }

        const hash = md5(this.code + '38fnjk3892henksjjklhnxj123!@')
        const data = `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
  <soap:Body>
    <VerificaBiglietto xmlns="https://wsfiscale.mailticket.it/">
      <biglietto>${this.code}</biglietto>
      <HSH>${hash.toUpperCase()}</HSH>
    </VerificaBiglietto>
  </soap:Body>
</soap:Envelope>`
        let result
        try {
          result = await axios.post('https://wsfiscale.mailticket.it/ServizioVerificaBiglietti.asmx', data, config)
          const parser = new DOMParser()
          const resultXML = parser.parseFromString(result.data, 'text/xml')
          const resultNode = resultXML.getElementsByTagName('VerificaBigliettoResult')
          if (resultNode && resultNode[0] && resultNode[0].innerHTML === 'VALIDO') {
            console.log('OK!')
            await this.saveUser()
          } else {
            throw new Error('Invalid Ticket')
          }
        } catch (e) {
          console.log(e)
          this.error = e.name + ': ' + e.message
        }
        this.saving = false
      }
    },

    async saveUser () {
      await this.$apollo.mutate({
        mutation: UpdateUser,
        variables: {
          id: this.$root.databaseUser.id,
          input: {
            spentTickets: (this.$root.databaseUser.spentTickets && Array.isArray(this.$root.databaseUser.spentTickets))
              ? this.$root.databaseUser.spentTickets.concat([this.code])
              : [this.code]
          }
        }
      })
    }
  }
}
</script>
